<template>
    <v-app>
        <div class="min-h-screen flex flex-col w-full relative bg-gradient-to-b from-neutral-50 to-neutral-100">
            <div class="flex-1 mx-auto overflow-hidden p-4 w-full relative">
                <!-- current view -->
                <router-view />
            </div>
        </div>
    </v-app>
</template>
  
<script setup>
</script>